var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-leadstatus"},[(_vm.status)?_c('v-chip',{staticClass:"mr-1",attrs:{"color":_vm.color,"dark":_vm.dark}},[_vm._v(" "+_vm._s(_vm.long)+" ")]):_c('v-chip',{staticClass:"mr-1",attrs:{"small":"","outlined":""}},[_vm._v(" Non Assegnata ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }